module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_EN.206b1b60.txt";